import contentful from 'libraries/contentful/client'
import { get } from 'lodash'

class ContentfulInformationPages {
    static async fetch() {
        const entries = await contentful.getEntries({ content_type: 'info' })
        const contentfulInformationPages: any[] = get(entries, 'items', [])
        return contentfulInformationPages;
    }
}

export default ContentfulInformationPages;